<template>
    <VPage title="คูปองส่วนลด">
        <div class="stadium-boosts">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1">
                    <span slot="tab">
                        <a-icon type="double-right" />
                        กำลังจะมาถึง
                    </span>
                    <Coupons :is-past="false" />
                </a-tab-pane>
                <a-tab-pane key="2">
                    <span slot="tab">
                        <a-icon type="history" />
                        ประวัติ
                    </span>
                    <Coupons :is-past="true" />
                </a-tab-pane>
            </a-tabs>
        </div>
    </VPage>
</template>
<script>
import Coupons from '@/components/Coupons.vue'
import VPage from '@/components/VPage.vue'

export default {
    components: {
        VPage,
        Coupons,
    },
}
</script>
